<script lang="ts" setup>
defineOptions({
  name: 'AppImage',
})

withDefaults(defineProps<AppImageProps>(), {
  alt: '',
  width: undefined,
  height: undefined,
})

interface AppImageProps {
  srcset: string
  src: string
  alt?: string
  width?: string | number | undefined
  height?: string | number | undefined
}

</script>

<template>
  <picture class="ui-app-image">
    <source
      :srcset="srcset"
      type="image/avif"
    >
    <img
      :src="src"
      :alt="alt"
      :width="width"
      :height="height"
      loading="lazy"
      decoding="async"
      v-bind="$attrs"
    >
  </picture>
</template>

<style lang="scss" scoped src="./_app-image.scss" />
